import React, { useState } from 'react';
import { List, Grid, Card } from 'semantic-ui-react';
import formatter from 'utils/formatter';
import { displayTitle, hasBillLabel } from 'utils/billDisplay';
import Header from 'components/Header';
import Message from 'components/Message';
import CancelGoButtons from 'components/CancelGoButtons';

export default function BillSummary({ bill, orders, cancelFn, billPaidFn }) {
  const [showConfirmation, setShowConfirmation] = useState(false);

  if (showConfirmation) {
    const formattedTotal = formatter.currency(bill.total);
    return (
      <div style={{ marginTop: '1em' }}>
        <Message headerText="Marcar cuenta como pagada">
          <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
            ¿Estás seguro de marcar esta cuenta como pagada?
          </p>
          
          <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
            <b>{displayTitle(bill)}</b> con <b>{orders.length}</b> {orders.length === 1 ? 'artículo' : 'artículos'}
            {hasBillLabel(bill) && (
              <span style={{ display: 'block', fontSize: '0.85em', color: '#666', marginTop: '0.35em', fontWeight: 'normal' }}>
                ID #{bill.id}
              </span>
            )}
            <br />
            <span style={{ fontSize: '2em', fontWeight: 'bold', display: 'block', margin: '0.5em 0' }}>
              {formattedTotal}
            </span>
          </p>

          <p style={{ textAlign: 'center', color: '#666', fontSize: '1em', marginBottom: '1.5em' }}>
            Una vez marcada como pagada, la cuenta quedará lista para ser cerrada.
          </p>

          <CancelGoButtons
            cancelFn={cancelFn}
            goText="marcar como pagada"
            goEnabled={true}
            goFn={billPaidFn}
          />
        </Message>
      </div>
    )
  }

  const combinedOrders = orders.reduce((acc, order) => {
    const existingOrder = acc.find(o => o.product_name === order.product_name);
    const totalPrice = order.unit_price * order.quantity;

    if (existingOrder) {
      existingOrder.quantity += order.quantity;
      existingOrder.totalPrice += totalPrice;
    } else {
      acc.push({ ...order, totalPrice });
    }

    return acc;
  }, []);

  return (
    <div style={{ fontSize: '1.3em', paddingBottom: '2em' }}>
      <Header text={displayTitle(bill)} />

      <Card fluid>
        <Card.Content>
          <List divided relaxed>
            { combinedOrders.map((order) => 
              <List.Item key={order.id} style={{ padding: '1em 0' }}>
                <Grid>
                  <Grid.Row style={{ paddingBottom: 0 }}>
                    <Grid.Column width={11} verticalAlign="top">
                      <p style={{ marginBottom: 0 }}>
                        { order.product_name }
                      </p>
                    </Grid.Column>
                    <Grid.Column width={5} verticalAlign="top" textAlign="right">
                      <p style={{ marginBottom: 0 }}>
                        { formatter.currency(order.unit_price) }
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid>
                  <Grid.Row style={{ paddingTop: 0 }}>
                    <Grid.Column width={11} verticalAlign="top" >
                      <p>x {order.quantity} </p>
                    </Grid.Column>
                    <Grid.Column width={5} verticalAlign="top" textAlign="right">
                      <p style={{ marginBottom: 0, fontWeight: 'bold' }}>
                        {formatter.currency(order.totalPrice)}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </List.Item>
            )}
          </List>
        </Card.Content>
      </Card>
      
      <Card fluid>
        <Card.Header>
          <List relaxed>
            <List.Item>
              <div style={{ textAlign: 'right', padding: '1em', fontSize: '20px' }}>
                Total a pagar
                <span style={{ marginLeft: '1em', fontWeight: 'bold' }}>
                { formatter.currency(bill.total) }
                </span>
              </div>
            </List.Item>
          </List>
        </Card.Header>
      </Card>
      
      <CancelGoButtons
        cancelFn={cancelFn}
        goText="marcar cuenta como pagada"
        goFn={ () => setShowConfirmation(true) }
        goEnabled={true}
      />
    </div>
  )
}